import React from 'react';

import {Grid} from '@mui/material';
import {useQuery} from 'react-query';

import API, {NoFlyZonePaginationProps} from '@wheeebo/polaris-api';
import {Head, Map, GoogleMapProvider, RightDrawer, useGoogleMap} from '@wheeebo/polaris-ui';

import {config} from '@components/Constants';
import NoFlyZoneCard from '@components/pages/noFlyZone/NoFlyZoneCard';

const NO_FLY_ZONE_SEARCH_RADIUS_METER = 10000;

function NoFlyZoneMap() {
  const {center} = useGoogleMap();
  const options: NoFlyZonePaginationProps = {
    latitude: center?.lat || 0,
    longitude: center?.lng || 0,
    radius: NO_FLY_ZONE_SEARCH_RADIUS_METER,
  };
  const {data} = useQuery(
    center ? API.NoFlyZones.listKey(options) : '',
    () => (center ? API.NoFlyZones.list(options) : undefined),
    {enabled: !!center},
  );
  return <Map apiKey={config.GOOGLE_MAP_API_KEY || ''} noFlyZones={data?.items} draggable />;
}

function NoFlyZoneListPage(): JSX.Element {
  return (
    <GoogleMapProvider>
      <Grid container spacing={1}>
        <Head title="No fly zones" />
        <Grid item xs={12}>
          <NoFlyZoneMap />
          <RightDrawer>
            <NoFlyZoneCard />
          </RightDrawer>
        </Grid>
      </Grid>
    </GoogleMapProvider>
  );
}

export default React.memo(NoFlyZoneListPage);
